import React, { useEffect, useState } from "react";
import adminService from "../services/adminService";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
 
 const Callback = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
 
  useEffect(() => {
    const handleCallback = async () => {
      const searchParams = new URLSearchParams(window.location.hash.substr(1));
      const accessToken = searchParams.get("access_token");
      const expiresIn = searchParams.get("expires_in");
 
      if (!accessToken || !expiresIn) {
        setErrorMessage("Access token or expiration time not found.");
        return;
      }
 
      try {
        const data = await adminService.verifyAuth(accessToken);
 
        console.log(data);
        console.log(typeof data);
        console.log(data.status);
        // localStore.setI  tem("profile", JSON.stringify(uobj));
        // localStorage.setItem("uid", data["id"]);
        console.log(!data);
        if (data?.status == 201 || data?.status == 200) {
          localStorage.setItem("accesstoken", accessToken);
          localStorage.setItem("expires_in", expiresIn);
          localStorage.setItem("userData", JSON.stringify(data.data));
          setTimeout(() => {
            window.location.href = "/login";
          }, 1000);
        } else {
          toast.error(data?.message);
          navigate("/");
        }
      } catch (error) {
        // localStore.clear();
        setErrorMessage("Error occurred while logging in. Please try again.");
        console.error(error);
        toast.error(error?.data?.message || "Internal Server Error");
        navigate("/");
      }
    };
 
    handleCallback();
    // eslint-disable-next-line
  }, []);
 
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-3"></div>
        <div className="col">
          {errorMessage ? (
            <div className="text-danger" role="alert">
              {errorMessage}
            </div>
          ) : (
            <div>
              <h2>Authentication complete</h2>
              <p>
                You may now close this window and return to the application.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Callback